import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesService } from 'mbs-ui-shared@services';
import { Observable, filter, map } from 'rxjs';

@Component({
  selector: 'mbs-payment-method-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment-method-button.component.html',
  styleUrls: ['./payment-method-button.component.css']
})
export class PaymentMethodButtonComponent {
  public subscriptionEditLink = this.licensesService.getSubscriptionEditLink();

  public get subscribeUrl(): string {
    return this.auth.subscriptionUrl;
  }

  public get isAutoPay(): Observable<boolean> {
    return this.balance.pipe(
      filter(Boolean),
      map((balance) => balance?.subscriptionEnabled)
    );
  }

  constructor(
    private auth: AuthFacade,
    private licensesService: LicensesService,
    @Inject(BALANCE_TOKEN) public balance: Observable<Balance>
  ) {}
}
